import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import LoginButton from './LoginButton';
import LogoutButton from './LogoutButton';
import './NavBar.css';

export default function NavBar() {
    const { isAuthenticated } = useAuth0();
    const className = ({ isActive }) => isActive ? 'nav-link active' : 'nav-link';

  return (
    <nav className="nav-bar">
      <div className="nav-inner">
        <NavLink className="nav-logo" to="/">Train Price Alerts</NavLink>
        <div className="nav-links">
          <NavLink to="/" className={className}>Home</NavLink>
          {isAuthenticated ? (
            <>
              <NavLink to="/create-alert" className={className}>Create Alert</NavLink>
              <LogoutButton />
            </>
          ) : (
            <LoginButton />
          )}
        </div>
      </div>
    </nav>
  );
}
